import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '../lib/api'
import type {
  StockTransfer,
  PaginatedStockTransfers,
  StockTransferFilters,
  CreateStockTransferPayload,
} from '../types/stock-transfers.types'

const STOCK_TRANSFER_QUERY_KEY = 'stock-transfers'

/** Список перемещений с фильтрами и пагинацией. */
export const useStockTransfers = (filters: StockTransferFilters = {}) => {
  return useQuery({
    queryKey: [STOCK_TRANSFER_QUERY_KEY, filters],
    queryFn: async (): Promise<PaginatedStockTransfers> =>
      apiClient.getStockTransfers(filters),
    staleTime: 30 * 1000,
    retry: 1,
  })
}

/** Детали одного перемещения. Запрос включается, когда задан id. */
export const useStockTransfer = (id: string | null) => {
  return useQuery({
    queryKey: [STOCK_TRANSFER_QUERY_KEY, 'detail', id],
    queryFn: async (): Promise<StockTransfer> =>
      apiClient.getStockTransfer(id as string),
    enabled: !!id,
    staleTime: 30 * 1000,
    retry: 1,
  })
}

/**
 * Создание перемещения. Синхронно уходит в 1С: при ошибке 1С мутация
 * зафейлится, и диалог покажет текст ошибки (документ не создаётся).
 */
export const useCreateStockTransfer = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (data: CreateStockTransferPayload) =>
      apiClient.createStockTransfer(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [STOCK_TRANSFER_QUERY_KEY],
      })
    },
  })
}
